<div
  class="w-full"
  [style.height]="height * 0.25 + 'rem'"
></div>
